import React from 'react';
import LegalDocumentLayout from '../components/legal/LegalDocumentLayout';

const PrivacyPage = () => <LegalDocumentLayout variant="privacy" />;

export default PrivacyPage;
